import { createFileRoute } from '@tanstack/react-router'
import { WhatWeDoPage } from '@/components/engineering/EngineeringPages'
import { localizedPageHead } from '@/lib/seo-head'

export const Route = createFileRoute('/{-$locale}/what-we-do')({
  head: ({ params }) => localizedPageHead('whatWeDo', params.locale),
  component: () => <WhatWeDoPage />,
})
